/**********************************************************************************************************************/
/* FILE: hafas_webapp_controller_linesearch.js                                                                        */
/**********************************************************************************************************************/
/* Controller.LineSearch */

HafasWebapp.prototype.Controller.LineSearch = {

  stationMarker: null,
  currentResult: null,
  currentSelection: 0,
  currentNearLines: undefined, // null means, there is a problem with getting the current position
  currentShownNearLines: null,
  currentLineAnimator: null,
  currentCoord: null,
  currentView: null,
  currentAlpha: null,
  // current latitude and longitude, coming from the location provider
  currentLat: undefined, // undefined means, location has not been checked yet. null means location has been checked but permission is missing or location could not be determined
  currentLon: undefined, // undefined means, location has not been checked yet. null means location has been checked but permission is missing or location could not be determined
  firstLocationUpdateDone: false,
  debouncedUpdateCurrentLocation: null,
  // previousSearch latitude and longitude, which were used for last nearby search
  previousSearchLat: null,
  previousSearchLon: null,
  deviceOrientationListener: null,
  deviceSensorController: null,
  stationCache: {},
  livemapIsStarted: false,
  livemapTriggeredByLSearch: false,
  lineDetailsShown: false,
  lastLineDetails: null,
  suggest: null,
  isJourneySelectorOpen: false,
  isMapShown: false,
  zoomStationCount: 3,
  mapContent: {polylines: [], locations: []},

  index: function () {
    var me = this;
    var controller = me.Controller.LineSearch;

    if (controller.currentView === "result") {
      controller.cleanup.bind(this)();
    }

    controller.currentView = 'index';

    controller.loadTemplates(function () {
      Hafas.bind(controller.renderIndex, me)();
      Hafas.bind(controller.registerDeviceSensors, me)();
    });
  },

  onReceiveCurrentLocation: function (response) {
    var controller = this.Controller.LineSearch;
    var coords = response.error ? null : response.browserPosition.coords;

    // the very first location update should be shown immediately
    // afterwards, the debounced version is used
    if (!controller.firstLocationUpdateDone) {
      controller.firstLocationUpdateDone = true;
      controller.updateCurrentLocation.call(this, coords);
    } else
      controller.debouncedUpdateCurrentLocation(coords);
  },

  registerDeviceSensors: function () {

    var me = this;
    var controller = me.Controller.LineSearch;

    if (controller.deviceSensorController)
    // already registered
      return false;

    controller.deviceSensorController = [];

    if (!controller.deviceOrientationListener) {
      var doC = {
        callAfterWait: true,
      };
      controller.deviceSensorController.push(doC);
      controller.deviceOrientationListener = Hafas.Util.debounce(Hafas.bind(controller.onDeviceOrientationChanged, controller), 500, doC);
      Hafas.Util.deviceOrientation.addListener(controller.deviceOrientationListener);
    }

    if (Hafas.Config.LineSearch.useNearLines) {
      var ucC = {
        callAfterWait: true,
      };
      controller.deviceSensorController.push(ucC);
      // wait at least 30 seconds for new location updates
      // because each time a network request is placed -> save data!
      controller.debouncedUpdateCurrentLocation = Hafas.Util.debounce(controller.updateCurrentLocation.bind(me), 30000, ucC);

      // position watcher does not deliver a position if browser was asked for position before (e.g. in SQ)
      // therefore we ask for actualPosition separately to ensure to always have a location
      var callback = controller.onReceiveCurrentLocation.bind(me);
      Hafas.Util.geo.getActualPosition(callback);
      Hafas.Util.geo.activateActualPositionWatcher(callback);
    }

    // register successful
    return true;
  },

  unregisterDeviceSensors: function () {
    if (!this.deviceSensorController)
    // nothing registered
      return;

    this.deviceSensorController.forEach(function (item) {
      // kill all remaining debounce functions as they are not needed anymore
      item.kill();
    });
    this.deviceSensorController = null;

    Hafas.Util.deviceOrientation.removeListener(this.deviceOrientationListener);
    this.deviceOrientationListener = null;

    Hafas.Util.geo.deactivateActualPositionWatcher();
  },

  onDeviceOrientationChanged: function (event) {
    this.currentAlpha = event.alpha;

    if (!this.currentShownNearLines)
      return;

    // this.adjustCompassNeedles();
  },

  /**
   * @method adjustCompassNeedles
   *
   * This function is responsible for adjusting the compass needles on devices with a gyroscope
   * It requires the compass needle icon to be adjusted to the top (north) by default.
   * Otherwise the compass needle will be misplaced
   */
  adjustCompassNeedles: function () {
    var me = this;
    var a = me.currentAlpha;

    if (a === null)
      return;

    var myLat = me.currentLat;
    var myLon = me.currentLon;

    Hafas('#HFS_LineSearchLinesNearby .lyr_lineCompass', true).forEach(function (item) {
      var line = me.currentShownNearLines[item.dataset.lineidx];
      var coords = line.locResolved.crd;

      // get bearing between location of line and my current location
      var rotation = parseInt(Hafas.Util.geo.getBearing(myLat, myLon, coords.y / 1000000, coords.x / 1000000) + a);
      var previousRotation = parseInt(item.dataset.rotation) || 0;

      // Following calculation is necessary to determine the shortest track between the old rotation and the new one
      // prevents css transition from going to 0 to 359 clockwise
      // -> instead sets the new rotation to -1, which is equivalent to 359, but a shorter way to animate
      rotation = Hafas.Util.geo.getShortestRotation(previousRotation, rotation);

      item.style.transform = 'rotateZ(' + rotation + 'deg)';
      // saving it in dataset as well, so we don't have to parse it from "style.transform"
      // when accessing it as the "previousRotation"
      item.dataset.rotation = rotation;
    });
  },

  loadTemplates: function (callback) {
    Hafas.Modules.Loader.loadTemplateFiles([
      'linesearch.atoms.html',
      'linesearch.index.html',
      'linesearch.result_overview.html',
      'linesearch.suggest.html'
    ], Hafas.bind(function () {
      callback();
    }, this));
  },

  updateCurrentLocation: function (coords) {
    var lat = null; // null means location has been checked but permission is missing or location could not be determined
    var lon = null; // null means location has been checked but permission is missing or location could not be determined

    if (coords) {
      lat = coords.latitude;
      lon = coords.longitude;
    }

    this.Controller.LineSearch.currentLat = lat;
    this.Controller.LineSearch.currentLon = lon;

    if (this.Controller.Map.instance != null) {
      this.Controller.LineSearch.showNearbyLines(lat, lon, this.Controller.Map.instance);
      this.Controller.LineSearch.showCurrentLocationOnMap();
    }
  },

  renderIndex: function () {

    if (Hafas.Modules.History)
      Hafas.Modules.History.addData("LineSearch", "index", {});

    var me = this;
    var model = {
      selectedLine: this.Controller.LineSearch.selectedLine,
      isLoading: Hafas.Config.LineSearch.useNearLines,
    };

    Hafas('#' + me.formContainer).innerHTML = Hafas.Modules.Render.renderTemplate("LineSearch_TplIndex", model);

    me.Controller.LineSearch.createSuggest();
    Hafas.Core.newType('HafasSegmentedControl', {holder: 'HFS_LineSearchSegConWrap'}).initiate();
    me.Controller.LineSearch.showCurrentLocationOnMap();

    Hafas.ps.pub('/GUI/form/show', [{}]);
    Hafas.ps.pub('/favorites/update');
    Hafas.ps.pub('/app/events/resize');
    Hafas.ps.pub('/app/contextLoaded/' + me.appContext);

    Hafas.Util.gui.focusTabOrMenuButton();
  },

  createSuggest: function () {
    var inputId = 'HFS_searchLineInput';

    this.suggest = Hafas.Core.newType("hafasSuggest", {
      input: inputId,
      config: {minChar: 0},
      suggestMode: 'LineSearch',
      renderTpl: 'LineSearch_TplLineSuggest',
      useFunctionButtons: false,
      onSelect: Hafas.bind(function (line) {
        this.setSelectedLine(line);
      }, this)
    });

    // if the user changes something, the form is dirty and a previously selected line must be cleared
    Hafas('#' + inputId).addEventListener('input', Hafas.bind(function () {
      this.selectedLine = null;
    }, this));

    // override default behaviour of suggest, because LineSearch is not using locations within suggest
    var overrides = this.suggest.overrides;

    overrides.buildRequestObject = this.instance.buildSearchLinesRequestObject;
    overrides.transformHCIData = this.instance.transformHCILineSearchData;
    overrides.customMergeFunction = function (_1, _2, sObj) {
      var list = sObj.suggestList;

      // only if there are no suggests, show history and favorites
      if (list.length === 0)
        list = list.concat(sObj.favoriteList).concat(sObj.historyList);

      return list;
    };

    overrides.getHistoryList = function (favoriteData) {
      return favoriteData.linesHistory;
    };
    overrides.getFavoritesList = function (favoriteData) {
      return favoriteData.lines;
    };
    overrides.getTopList = function () {
      return [];
    };
  },

  clearCurrentLocationOnMap: function (map) {
    if (!this.currentPositionMarker)
      return;

    map.hideContent(this.currentPositionMarker);
    map.removeContent(this.currentPositionMarker);
    this.currentPositionMarker = null;
  },

  showCurrentLocationOnMap: function () {
    var map = this.main.Controller.Map.instance;
    var lat = this.currentLat;
    var lon = this.currentLon;

    if (!lat || !lon)
      return;

    lat *= 1000000;
    lon *= 1000000;

    var markerCfg = Hafas.Config.Maps.Marker;
    var markerParams = {
      type: 'location',
      coord: Hafas.Core.newType("hafasCCoord", {
        lon: lon,
        lat: lat
      }),
      text: Hafas.Modules.i18n.get("Suggest.t_N_CurrentPosition"),
      imageurl: Hafas.Util.getMarkerPath('DEFAULT_MARKER_URL_CURRENT_POS'),
      hotspot: {
        x: markerCfg.DEFAULT_MARKER_URL_CURRENT_POS_WIDTH / 2,
        y: markerCfg.DEFAULT_MARKER_URL_CURRENT_POS_HEIGHT / 2
      },
      imagewidth: markerCfg.DEFAULT_MARKER_URL_CURRENT_POS_WIDTH,
      imageheight: markerCfg.DEFAULT_MARKER_URL_CURRENT_POS_HEIGHT,
      onclick: function (crdLat, crdLon) {
        return function () {

          var coord = Hafas.Core.newType("hafasCCoord", {
            lon: crdLon,
            lat: crdLat
          });

          var callback = function (data, common) {
            var loc = (data || [])[0];
            Hafas.Util.getRef('ico', common, loc);
            Hafas.ps.pub('/map/clickOnLocation', [map, loc]);
            if (Hafas.Config.Maps.toolbox.showLines == true && loc.type == 'S' && typeof common == 'undefined') {
              Hafas.ps.pub('/map/clickOnLocation/getLocDetails', [loc]);
            }
          };

          Hafas.Util.geo.reverseLookup(coord, callback, callback, {});
        };
      }(lat, lon)
    };

    this.clearCurrentLocationOnMap(map);
    this.currentPositionMarker = map.createContent(markerParams);
    map.showContent(this.currentPositionMarker);

    if (this.currentView == 'index') // Wenn man sich nicht mehr im Input Formular befindet soll auch nicht mehr auf aktuelle Position gezoomt werden
      map.centerToContent(this.currentPositionMarker);
  },

  showNearbyLines: function (lat, lon) {

    lat = lat || this.currentLat;
    lon = lon || this.currentLon;

    if (!lat || !lon) {
      // if lat and lon are undefined, we do not want to update our lines nearby
      // as the loading indicator would be overwritten by an empty lines list
      // however, as long as lat and lon are undefined, the loading indicator should be shown
      // as the browser is still trying to get a location
      if (lat !== undefined && lon !== undefined) {
        // null means, position was not found or permission has been denied
        this.currentNearLines = null;
        this.updateLinesNearby();
      }

      return;
    }

    lat = parseInt(lat * 1000000);
    lon = parseInt(lon * 1000000);
    this.currentCoord = Hafas.Core.newType("hafasCCoord", {lat: lat, lon: lon});

    // don't trigger a new search if lat and lon have not changed since last search
    if (lat === this.previousSearchLat && lon === this.previousSearchLon) {
      this.updateLinesNearby();
    } else {
      this.previousSearchLat = lat;
      this.previousSearchLon = lon;

      this.instance.searchNearbyLines({
        callback: Hafas.bind(function (lineList) {
          this.currentNearLines = lineList;
          this.updateLinesNearby();
        }, this), coord: {lat: lat, lon: lon}
      });
    }
  },

  setSelectedLine: function (line) {
    var newVal = line.prodResolved.name;
    var lineSearchInput = Hafas('#HFS_searchLineInput', false);
    this.selectedLine = line;

    if (lineSearchInput !== null && (lineSearchInput.value !== newVal || Hafas.Util.location.isEqualLine(this.suggest?.activeLoc, line) === false)) {
      this.suggest.setLocation(line);

      var label = Hafas('label[for="HFS_searchLineInput"]');
      Hafas.Modules.a11y.Announce.polite(Hafas.Modules.i18n.get('a11y.announce.t_N_ElementTextChanged', {
        element: label.textContent,
        text: newVal
      }));
    }
  },

  /********************************************************************/
  /********** FORM PAGES **********************************************/
  /********************************************************************/

  renderLinesNearby: function (lineList) {
    // an undefined list is useless, therefore do nothing
    if (lineList === undefined)
      return;

    var renderTarget = 'HFS_LineSearchLinesNearby';

    // check if target exists
    if (!document.getElementById(renderTarget))
      return;

    var me = this;
    var showLineList = [];

    var maxLines = Hafas.Config.LineSearch.maxLinesNear || Number.MAX_SAFE_INTEGER;

    if (lineList) {
      var appliedFilters = [];
      this.lineFilter.forEach(function (item) {
        if (item.active)
          appliedFilters.push(item.bit);
      });

      for (var i = 0; i < lineList.length && i < maxLines; i++) {
        var line = lineList[i];
        line.isFav = this.checkFavLine(line.lineId);


        if (appliedFilters.length === 0 || appliedFilters.indexOf(line.prodResolved.cls) !== -1)
          showLineList.push(line);
      }

      this.currentShownNearLines = showLineList;
    }

    var model = {
      lists: [],
      showCompass: Hafas.Util.deviceOrientation.isSupported(),
      filterButtons: this.lineFilter,
      emptyListText: lineList ? 'LineSearch.index.t_N_NoNearLines' : 'common.locationErrors.t_N_positionUnavailable',
    };


    // list should only be added if there are items available within
    // becuase the hint "list is empty" within the template is only shown if there are no lists available within the model
    if (showLineList.length > 0) {
      // there is only one list to show for lines nearby
      model.lists.push({
        type: 'nearby',
        lines: showLineList
      });
    }

    var focusSelector = Hafas.Util.gui.getFocusElementSelector();
    Hafas.Modules.Render.render({
      target: renderTarget,
      template: 'LineSearch_AtomTplLineList',
      model: model
    }, function () {
      Hafas.Util.gui.restoreFocus(focusSelector);
      // me.adjustCompassNeedles();
    });
  },

  updateLinesNearby: function () {
    this.renderLinesNearby(this.currentNearLines);
  },

  selectLineFromNearList: function (data) {
    var index = data;
    var hitSearch = true;
    if(typeof data === 'object'){
      index = data.id;
      hitSearch = data.hitSearch;
    }

    this.setSelectedLine(this.currentShownNearLines[index]);
    if(hitSearch)
      this.searchLine('selectLineFromNearList');

    Hafas.ps.pub('/linesearch/closePopover',[]);
    // send the input id as a type to highlightingInput method
    Hafas.ps.pub('/GUI/common/highlightingInput', [{type:'linesearch'}]);
  },

  selectLineFromFavoritesModule: function (data,storage) {
    if (!Hafas.Modules.Favorites)
      return;

    var line = this.Controller.Favorites.instance.getLineById(data.lineId, storage);
    this.Controller.LineSearch.setSelectedLine(line);
    if(data.hitSearch)
      this.Controller.LineSearch.searchLine('selectLineFromFav');
    return;
  },

  selectLineFromFav: function (data) {
    Hafas.bind(this.Controller.LineSearch.selectLineFromFavoritesModule, this)(data, 'lines');
    Hafas.ps.pub('/linesearch/closePopover',[]);
  },

  selectLineFromHist: function (lineId) {
    Hafas.bind(this.Controller.LineSearch.selectLineFromFavoritesModule, this)(lineId, 'linesHistory');
    Hafas.ps.pub('/linesearch/closePopover',[]);
  },

  setProductFormFilter: function (bit, trigger) {
    var filterItem = Hafas.Util.array.getEntryByPropertyValue(this.lineFilter, 'bit', bit);
    filterItem.entry.active = !trigger.getAttribute('aria-pressed');
    this.announceFilterChange(bit, filterItem.entry.active);
    this.updateLinesNearby();
  },

  announceFilterChange: function (bit, filterStatus) {
    for (var i = 0; i < this.lineFilter.length; i++) {
      if (this.lineFilter[i].bit === bit) {
        var announcement = Hafas.Modules.i18n.get("a11y.t_N_prodFilter") + " " + Hafas.Modules.i18n.get(this.lineFilter[i].product.name) + " ";
        announcement += (filterStatus) ? Hafas.Modules.i18n.get("a11y.t_N_activated") : Hafas.Modules.i18n.get("a11y.t_N_deactivated");
      }
    }
    Hafas.Modules.a11y.Announce.assertive(announcement);
  },

  searchLine: function (data) {
    var selectedLine = this.selectedLine;
    if (selectedLine == null) {
      Hafas("#HFS_searchLineInput").focus();
      return;
    }

    var query = {lineId: selectedLine.lineId};
    this.instance.searchLineDetails(query, Hafas.bind(function (result) {
      this.showLineSearchOverview(result);
      this.addLineToHistory(result);
    }, this));
    this.showSearchWaitHint();
  },

  toggleSearchWaitHint: function (show) {
    var button = Hafas('#HFS_LineSearchSubmit');

    if (!button)
    // can happen if detail view is restored from history
      return;

    if (show)
      button.setAttribute('disabled', true);
    else
      button.removeAttribute('disabled');

  },

  showSearchWaitHint: function () {
    // verstecke Formular
    Hafas.ps.pub('/GUI/form/hide', [{}]);
    // zeige LineSearch Overview
    Hafas.ps.pub('/GUI/results/overview/show', [{}]);
    // Ghostloading Elements anzeigen
    var himSearchResultContainer = Hafas('#LineSearch_ResultOverview',false);
    var countArr = new Array(8);
    for(var c=0; c < countArr.length;c++){
      countArr[c] = {};
    }
    // Loading Screen anzeigen
    himSearchResultContainer.innerHTML = Hafas.Modules.Render.renderTemplate("LineSearch_TplLoadingView",{jnyList: this.selectedLine.jnyList, line: this.selectedLine, count: countArr });
    // InfiniteLoader initialisieren
    var loaderHtml = Hafas.Modules.Render.renderTemplate("Common_AtomTplLoaderBarInfinite", {id: "HFS_LineSearch_OverviewLoader"});
    Hafas('#HFS_LineSearchResultOverview').insertAdjacentHTML('afterbegin', loaderHtml);

    // Aktuelle View bereits auf Result setzen
    this.currentView = "result";

  },

  hideSearchWaitHint: function () {
    this.toggleSearchWaitHint(false);
  },


  /********************************************************************/
  /******** RESULT PAGES **********************************************/
  /********************************************************************/

  showLineSearchOverview: function (result, selectedIndex) {
    if(this.currentView != "result") return;

    this.unregisterDeviceSensors();
    this.hideSearchWaitHint();

    this.currentView = "result";

    this.isJourneySelectorOpen = false;
    var model = {
      viewHeader: {}
    };
    if (!result) {
      // todo: Fehlerbehandlung error
      console.warn(err.msg);
    } else {
      this.currentResult = result;

      model.lineResult = result;
      model.viewHeader.title = Hafas.Modules.i18n.get("LineSearch.results.t_N_ResultViewHeader");
      Hafas.Modules.Render.render({
        file: 'linesearch.result_overview.html',
        target: 'LineSearch_ResultOverview',
        template: 'LineSearch_TplResultOverview',
        model: model
      }, Hafas.bind(function () {

        // verstecke Formular
        Hafas.ps.pub('/GUI/form/hide', [{}]);
        // zeige LineSearch Overview
        Hafas.ps.pub('/GUI/results/overview/show', [{}]);
        Hafas.ps.pub('/app/events/resize');
        this.selectJourney(selectedIndex || 0);

        // Focus back button
        Hafas.Util.gui.focusFirstElement('#HFS_DocumentResultOverview');
      }, this));
    }
  },

  selectJourney: function (index) {
    var me = this;
    this.currentSelection = index;
    this.lastLineDetails = null;

    var model = {
      jnyList: this.currentResult.jnyList,
      currentJny: this.currentResult.jnyList[index],
      line: this.currentResult,
      isFavLine: this.checkFavLine(this.currentResult.lineId)
    };

    if (Hafas.Config.Switches.useHimInterface) {
      var resolvedHIMLink = this.main.himInterface.getLink({
        type: 'createMsg_LineSearch',
        journey: this.currentResult.jnyList[index],
        station: this.currentResult.jnyList[index].stopList[0].location
      });

      model.himCreateMsgLinkResolved = resolvedHIMLink;
    }

    for (var j in model.jnyList) {
      model.jnyList[j].active = false;
    }
    model.jnyList[index].active = true;
    var oldFocusSelector = Hafas.Util.gui.getFocusElementSelector();
    Hafas.Modules.Render.render({
      target: Hafas("#HFS_LineSearchResultOverview"),
      template: 'LineSearch_TplActionsResultWrap',
      model: model
    }, function () {
      Hafas.Core.newType('HafasSelectBox', {
        holder: 'HFS_LineSearchJnySelectBoxHolder',
        callback: function (params) {
          me.selectJourney(params.value);
        }
      }).initiate();

      Hafas.Util.gui.restoreFocus(oldFocusSelector);
      Hafas.bind(me.showLineDetails, me)(me.currentResult.jnyList[index]);
      Hafas.ps.pub('/app/events/resize');
    });
  },

  showLineDetails: function (result) {
    var model = {
      stopList: result.stopList,
      prod: result.product
    };

    var stopList = result.stopList;

    if (this.lineDetailsShown) {
      Hafas.ps.pub('/map/closeToolboxItem', []);
    }

    this.lastLineDetails = result;
    this.lineDetailsShown = true;
    this.stationCache = {};
    this.currentStopIdDict = {};

    var loc = stopList[0].location;
    var maxX = loc.crd.x;
    var minX = loc.crd.x;
    var maxY = loc.crd.y;
    var minY = loc.crd.y;

    for (var i = 0; i < stopList.length; i++) {
      var stop = stopList[i];
      stop.number = i + 1;
      this.stationCache[stop.location.extId] = stop.location;
      this.currentStopIdDict[stop.location.extId] = i;
      maxX = Math.max(maxX, stop.location.crd.x);
      minX = Math.min(minX, stop.location.crd.x);
      maxY = Math.max(maxY, stop.location.crd.y);
      minY = Math.min(minY, stop.location.crd.y);
    }

    var lineBoundingBox = {
      sw: Hafas.Core.newType("hafasCCoord", {lon: minX, lat: minY}),
      ne: Hafas.Core.newType("hafasCCoord", {lon: maxX, lat: maxY})
    };

    // Ergebnisse weiterleiten, werden von Timetable gebraucht /mroe
    Hafas.ps.pub('/linesearch/results', [model]);

    Hafas.Modules.Render.render({
      file: 'linesearch.index.html',
      target: 'HFS_LineSearchOverviewHolder',
      template: 'LineSearch_TplResultStopList',
      model: model
    }, Hafas.bind(function (html) {
      Hafas.ps.pub('/app/events/resize', []);
      if (Hafas.Config.Switches.useMap) {
        this.drawLineToMap(result);
      }
      this.addClickEventsToStations();
    }, this));

    var jouneyFilterList = [
      {type: "PID", mode: "INC", value: result.product.pid},
      {type: "DFLG", mode: "INC", value: result.dirFlg}
    ];

    if (!this.livemapIsStarted) {
      this.livemapTriggeredByLSearch = true;
      Hafas.ps.pub('/livemap/start', []);
      this.livemapIsStarted = true;
    }
    Hafas.ps.pub("/mobilityradar/journeys/setAllProductClass/webapp", [false, false]);
    Hafas.ps.pub('/livemap/setJourneyFilter', [jouneyFilterList, {
      restart: false,
      ignoreMapState: true,
      customBoundingBox: lineBoundingBox
    }]);

    // TODO Nach dem AWT 2017 wieder entfernen. (Oder doch nicht da das HCI es nicht richtig filtert....)
    var trainFilter = Hafas.bind(function (train) {
      if (this[train.prevStop.extId] >= this[train.nextStop.extId]) {
        return false;
      }
      return true;
    }, this.currentStopIdDict);

    this.currentLineAnimator = Hafas.Core.newType("hafasLineAnimator", {
      holder: Hafas("#HFS_LineSearchOverviewHolder"),
      trainFilter: trainFilter
    });

    Hafas.ps.pub('/map/closeToolboxItem', []);

    if (this.isMapShown) {
      this.showMap();
    } else {
      if (Hafas.Modules.History)
        Hafas.Modules.History.addOrUpdateData("LineSearch", "result", {
          result: this.currentResult,
          selectedIndex: this.currentSelection
        });
    }
  },

  /**
   * Redraw the current line, e.g. when changing the color scheme.
   */
  redrawLine: function () {
    var lsController = this.main.Controller.LineSearch;
    if (lsController.lastLineDetails) {
      Hafas.bind(lsController.drawLineToMap, this)(lsController.lastLineDetails);
      Hafas.bind(lsController.addClickEventsToStations, this)();
    }
  },

  drawLineToMap: function (journey) {
    this.main.Controller.LineSearch.clearMap.bind(this.main)();
    var map = this.main.Controller.Map.instance;

    // Build line polygon based on hci data
    if(journey.polyG !== undefined) {
      var polylineData = [];
      for (var p = 0; p < journey.polyG.polyXLResolved.length; p++) {
        polylineData = polylineData.concat(Hafas.Util.decodeGooglePolyline(journey.polyG.polyXLResolved[p].crdEncYX));
      }
    }else{
      var polylineData = this.createPolylineFromStopList(journey);
    }

    var polylineColors = journey.product.icoResolved;
    // Get current color scheme. Use "light" as fallback if server sent no dark mode colors.
    var isDark = Hafas.Core.getColorScheme() === 'dark';
    var currentColorScheme = isDark && polylineColors.dark ? 'dark' : 'light';

    var polylineParams = {
      color: polylineColors[currentColorScheme].bg,
      zIndex: 120,
      border: Hafas.Config.Maps.useLineBorders,
      borderColor: Hafas.Config.Maps.LINE_BORDER_COLOR,
      useArrows: true,
      opacity: 1,
      width: 5
    };
    this.mapContent.polylines.push(Hafas.Util.maps.showHCIPolyline(polylineData, map, polylineParams));

    var showFlyoutHint = ", " + Hafas.Modules.i18n.get('Map.a11y.t_N_showFlyoutHint');
    var startEndStopHint = "";
    for (var i = 0; i < journey.stopList.length; i++) {
      if (i < journey.stopList.length - 1) {
        startEndStopHint = Hafas.Modules.i18n.get('Map.a11y.t_N_startStop');
      } else {
        startEndStopHint = Hafas.Modules.i18n.get('Map.a11y.t_N_endStop');
      }
      var loc = journey.stopList[i].location;
      var icon = journey.product.icoResolved;
      currentColorScheme = isDark && icon.dark ? 'dark' : 'light';
      var html = "<span class='hfs_stationName' data-extId='" + loc.extId + "'><span class='lyr_srOnly'>" + startEndStopHint +  "</span>" + loc.name + "<span class='lyr_srOnly'>" + showFlyoutHint + "</span></span>";
      this.mapContent.locations.push(Hafas.Util.maps.showHCILocation(loc, map, {
        type: "container",
        html: html
      }, false, {backgroundColor: icon[currentColorScheme].bg}));

      this.mapContent.locations.push(Hafas.Util.maps.showHCILocation(loc, map, null, false, {backgroundColor: icon[currentColorScheme].bg}));
    }

    map.centerToContent(this.mapContent.polylines[0]);
    this.showCurrentLocationOnMap();
  },
  /**
   * removes map content (that has been created in the line search context)
   *
   * @method clearMap
   */
  clearMap: function () {
    var map = this.Controller.Map.instance;
    var controller = this.Controller.LineSearch;

    for (var i = 0; i < controller.mapContent.polylines.length; i++) {
      map.hideContent(controller.mapContent.polylines[i]);
      map.removeContent(controller.mapContent.polylines[i]);
    }

    for (var i = 0; i < controller.mapContent.locations.length; i++) {
      map.hideContent(controller.mapContent.locations[i]);
      map.removeContent(controller.mapContent.locations[i]);
    }

    controller.clearCurrentLocationOnMap(map);

    controller.mapContent.polylines = [];
    controller.mapContent.locations = [];
  },
  /**
   * removes livemap related content (that has been created in the line search context) from the map
   *
   * @method clearLivemap
   */
  clearLivemap: function(){
    // Clear Livemap related content
    if (this.Controller.LineSearch.livemapTriggeredByLSearch) {
      this.Controller.LineSearch.livemapTriggeredByLSearch = false;
      Hafas.ps.pub('/livemap/stop');
    }

    Hafas.ps.pub("/livemap/updateLivemapContext", []);
    Hafas.ps.pub("/livemap/clearJourneyFilter", [false, true]);
  },

  createPolylineFromStopList: function (journey) {
    var coodList = [];
    for (var i = 0; i < journey.stopList.length; i++) {
      var stop = journey.stopList[i];
      coodList.push(Hafas.Util.geo.hciCrdToHafasCoord(stop.location.crd));
    }
    return coodList;
  },


  addClickEventsToStations: function () {
    var stationLabels = Hafas("#HFS_PageMap .hfs_stationName", true);

    for (var i = 0; i < stationLabels.length; i++) {
      if (i != 0 && i != stationLabels.length - 1)
        stationLabels[i].parentNode.style.display = "none";
      stationLabels[i].onclick = Hafas.bind(function () {
        this.app.setActiveStation(this.node.getAttribute("data-extId"));
      }, {node: stationLabels[i], app: this});
    }
  },

  hideLineDetails: function () {
    this.lineDetailsShown = false;
    this.lastLineDetails = null;
    this.clearMap.bind(this.main)();
    Hafas.ps.pub("/mobilityradar/journeys/setAllProductClass/webapp", [false, false]);
    Hafas.ps.pub("/livemap/clearJourneyFilter", [false]);
  },

  setActiveStation: function (extId) {
    // is prevented, if user clicks on an animated train
    // in this case, the click should not select a station
    if (window.event && window.event.defaultPrevented)
      return;

    // if webapp is in mobile mode
    if (this.main.layoutClass === 'small') {
      var mobileAction = Hafas.Config.LineSearch.selectLocationAction;

      if (mobileAction === 'JumpToSQ') {
        var location = this.stationCache[extId];
        var locKey = Hafas.Modules.Render.objectKeeper.keep(location);
        Hafas.ps.pub('/sq/searchFromOtherContext', [locKey, "info"]);
        return;
      } else if (mobileAction === 'JumpToMap') {
        this.showMap();
      }
    }

    var showAll = false;
    var stations = Hafas("#HFS_LineSearchOverviewHolder .lyr_itemResult", true);
    for (var i = 0, size = stations.length; i < size; i++) {
      var station = stations[i];

      // more than one active station can be found
      // if station is passed twice on a line
      // BUS 23 (BVO Busverkehr Ostwestfalen) is an example
      var isSelected = station.dataset.extid == extId;
      var isActive = station.hasClassName('lyr_active');
      // User clicked on a station, although it has been selected before
      // Means that selectio should be removed for all items
      if (isSelected && isActive)
        showAll = true;

      if (isSelected && !showAll) {
        station.addClassName('lyr_active');
        station.setAttribute('aria-selected', true);
      } else {
        station.removeClassName('lyr_active');
        station.removeAttribute('aria-selected');
      }
    }

    var mapStationLabels = Hafas("#HFS_PageMap .hfs_stationName", true);

    if (showAll) {
      this.drawLineToMap(this.lastLineDetails);
      this.addClickEventsToStations();
      Hafas.ps.pub('/map/closeAllToolboxItems');
    } else {
      for (i = 0; i < mapStationLabels.length; i++) {
        var label = mapStationLabels[i];
        var labelParent = label.parentNode;

        label.removeClassName('hfs_active');
        labelParent.style.display = '';

        if (label.dataset.extid != extId)
          labelParent.style.display = 'none';
        else
          label.addClassName('hfs_active');
      }

      this.showMapToolboxForStation(extId);
      this.zoomMapToStation(this.stationCache[extId]);
    }
  },

  toggleMap: function (show) {
    var addOrRemove = show ? 'addClassName' : 'removeClassName';

    var resultDiv = Hafas(".lyr_lineSearchResultWrap");
    if (resultDiv)
      resultDiv[addOrRemove]("js_hideInMobile");

    var mapDiv = Hafas("#HFS_PageMap");
    if (mapDiv) {
      mapDiv[addOrRemove]("js_showInLinesearch");
    }

    var pageContentDiv = Hafas("#HFS_PageContent");
    if (pageContentDiv) {
      pageContentDiv[addOrRemove]("js_heightAuto")
    }

    var header = Hafas("#HFS_LineSearchViewHeader");
    if (header)
      header[addOrRemove]("js_showMapInLinesearch");

    if (show && Hafas.Modules.History)
      Hafas.Modules.History.addOrUpdateData("LineSearch", "map", {
        result: this.currentResult,
        selectedIndex: this.currentSelection
      });

    this.isMapShown = show;

    // TODO: Für IE11 Fix ein eigenständiges Event erstellen, das ist hier notwendig
    Hafas.ps.pub('/app/events/resize');
  },

  showMap: function () {
    this.toggleMap(true);
  },

  hideMap: function () {
    this.toggleMap(false);
  },

  zoomMapToStation: function (station) {

    function getCoordFromStation(s) {
      return Hafas.Core.newType("hafasCCoord", {
        lat: s.crd.y,
        lon: s.crd.x
      })
    }

    this.main.Controller.Map.instance.centerToGeo(getCoordFromStation(station), Hafas.Config.Maps.searchPredefinedZoom,{animate:false});
  },

  toggleLineFavorite: function (lineId, source, add) {
    var line;

    switch (source) {
      case "search":
        line = this.currentResult;
        break;
      case "nearby":
        var result = Hafas.Util.array.getEntryByPropertyValue(this.currentNearLines, 'lineId', lineId);
        if (result)
          line = result.entry;
        break;
    }

    if (add) {
      if (source === 'history') {
        Hafas.ps.pub('/favorites/addLineFromHist', [lineId]);
      }
      else {
        Hafas.ps.pub('/favorites/addLineToFav', [line]);
      }
    }
    else {
      Hafas.ps.pub('/favorites/removeLine', [lineId]);
    }

    if (source === "search") {
      // Favoritenstern neu rendern
      var model = {
        jnyList: this.currentResult.jnyList,
        currentJny: this.currentResult.jnyList[this.currentSelection],
        line: this.currentResult,
        isFavLine: this.checkFavLine(this.currentResult.lineId)
      };

      var focusSelector = Hafas.Util.gui.getFocusElementSelector();
      Hafas.Modules.Render.render({
        target: Hafas('[id="HFS_LineSearchOverviewHeader_' + line.lineId + '"]'), // lines can contain special characters, therefore the normal #-selector is not applicable
        template: 'LineSearch_LineDetails',
        model: model
      }, function () {
        Hafas.Util.gui.restoreFocus(focusSelector);
      });
    }
  },

  saveLineAsFavorite: function (lineId, source) {
    this.toggleLineFavorite(lineId, source, true);
  },

  deleteLineFromFavorite: function (lineId, source) {
    if (source === "search")
      lineId = this.currentResult.lineId;

    this.toggleLineFavorite(lineId, source, false);
  },

  checkFavLine: function (lineId) {
    var result = false;

    if (Hafas.Modules.Favorites) {
      var tmpFav = Hafas.Modules.Favorites.getInstances();
      if (tmpFav.length > 0) {
        var favorites = tmpFav[0];
        result = favorites.isLineStored(lineId);
      }
    }

    return result;
  },

  addLineToHistory: function (line) {
    Hafas.ps.pub('/favorites/addLineToHistory', [line]);
  },

  favoritesUpdated: function () {
    this.updateLinesNearby();
  },

  showMapToolboxForStation: function (extId) {
    Hafas.ps.pub('/map/clickOnLocation', [this.main.Controller.Map.instance, this.stationCache[extId], null, {}, {lazyLoadLines: false}]);
  },

  closeView: function (histData) {
    switch (histData.view) {
      case "index":
        Hafas.ps.pub('/GUI/form/hide', [{}]);
        Hafas.ps.pub('/GUI/results/overview/hide', [{}]);
        Hafas.bind(this.Controller.LineSearch.unregisterDeviceSensors, this.Controller.LineSearch)();
        this.Controller.LineSearch.currentView = 'index';
        break;
      case "result":
        Hafas.bind(this.Controller.LineSearch.hideLineDetails, this.Controller.LineSearch)();
        Hafas.ps.pub('/GUI/results/overview/hide', [{}]);
        break;
      case "map":
        this.Controller.LineSearch.hideMap();
        Hafas.ps.pub('/GUI/map/hide', []);
        break;
    }
  },

  restoreView: function (histData) {
    var view = histData.view;
    switch (view) {
      case "index":
        Hafas.bind(this.Controller.LineSearch.renderIndex, this)();
        Hafas.bind(this.Controller.LineSearch.registerDeviceSensors, this)();
        Hafas.bind(this.Controller.LineSearch.updateLinesNearby, this.Controller.LineSearch)();
        break;
      case "result":
        Hafas.bind(this.Controller.LineSearch.showLineSearchOverview, this.Controller.LineSearch)(histData.data.result, histData.data.selectedIndex);
        break;
      case "map":
        Hafas.bind(this.Controller.LineSearch.showLineSearchOverview, this.Controller.LineSearch)(histData.data.result, histData.data.selectedIndex);
        Hafas.bind(this.Controller.LineSearch.showMap, this.Controller.LineSearch)();
    }
  },

  showListsPopover: function (data,triggerElem){
    var _me = this;
    var triggerParent = triggerElem.parentNode;
    triggerParent.addClassName('lyr_selectedFav');
    if(this.Controller.LineSearch.popover) {
      Hafas.bind(_me.Controller.LineSearch.hideListsPopover, _me)();
    }
    data.popoverCloseEvent = '/linesearch/closePopover';
    this.Controller.LineSearch.popover = Hafas.Core.newType("HafasOverlay", {
      app: _me,
      title: '',
      anchorElement: triggerParent,
      anchoredOverlay: 'DESKTOP',
      outputHTML: Hafas.Modules.Render.renderTemplate("LineSearch_AtomPopover", data),
      cssClass: 'lyr_locationSelectPopover',
      onClose: function () {
        var anchor = this.Controller.LineSearch.popover.getAnchorElement();
        if(anchor){
          anchor.removeClassName('lyr_selectedFav');
        }
        this.Controller.LineSearch.popover = null;
        Hafas.ps.pub('/favorites/trackDialogAction',['dialog-cancelled']);
      }.bind(this),
      callback: function (html, err) {

      }
    });
  },

  hideListsPopover:function (){
    var _me = this;
    if(this.Controller.LineSearch.popover){
      var anchor = _me.Controller.LineSearch.popover.getAnchorElement();
      if(anchor){
        anchor.removeClassName('lyr_selectedFav');
      }
      this.Controller.LineSearch.popover.close();
      this.Controller.LineSearch.popover = null;
      Hafas.ps.pub('/favorites/trackDialogAction',['dialog-cancelled']);
    }
  },

  cleanup: function () {
    // Call functions to clear the map
    Hafas.bind(this.Controller.LineSearch.clearMap, this)();
    Hafas.bind(this.Controller.LineSearch.hideMap, this.Controller.LineSearch)();

    // unregister device sensors which also leads to removing the current geo position from the map
    Hafas.bind(this.Controller.LineSearch.unregisterDeviceSensors, this.Controller.LineSearch)();

    // Call function to clear the livemap contents
    this.Controller.LineSearch.clearLivemap.bind(this)();

    Hafas.ps.pub('/GUI/results/overview/hide', [{}]);
    Hafas.ps.pub('/GUI/form/hide', [{}]);
  },

  /**
   * clears all input data (including options)
   *
   * @method
   */
  clearInput: function () {
    // Entferne aktuellen History-Eintrag, da nachfolgend über switchContext ein neuer hinzu kommt
    Hafas.Modules.History.removeCurrentStep("index", () => {
      Hafas.ps.pub('/app/switchContext', [{context: 'LineSearch', method: 'index'}])
    });

    var me = this;
    me.Controller.LineSearch.selectedLine = undefined;
    me.Controller.LineSearch.suggest.resetLocation();

    Hafas.Modules.a11y.Announce.assertive(Hafas.Modules.i18n.get('common.menu.t_N_clearInput_success'));
  }

};
